export default __webpack_public_path__ + "static/octovisuals-74e8a266e1363087354dd114478bcc76.png";